import { Link } from 'react-router'
import React, { Component } from 'react'
import { Form, Button, Image, Overlay, Popover } from 'react-bootstrap'
import SessionActions from '../actions/SessionActions'
import SessionStore from '../stores/SessionStore'
import '../styles/Login.css'
import FaceAPI from '../apis/FaceAPI'
import GoogleLogin from './GoogleLogin'
import HandleException from '../utils/HandleException'
import ErrorStore from '../stores/ErrorStore'
import LogoImg from './LogoImg'

const clientId = process.env.GOOGLE_CLIENTID

export default class LoginCard extends Component {
  constructor(props) {
    super(props)
    this.emailRef = target => this.setState({ emailState: target })
    this.passwordRef = target => this.setState({ passwordState: target })
    this.state = {
      email: '',
      password: '',
      validationMessage: {}
    }

    this.onLogin = this.onLogin.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.validateForm = this.validateForm.bind(this)
    this.onLoginFacebook = this.onLoginFacebook.bind(this)
    this.onLoginGoogle = this.onLoginGoogle.bind(this)
    this.errorGoogle = this.errorGoogle.bind(this)
    this.container = React.createRef()
    this.componentId = 'logincard'
    this.onError = this.onError.bind(this);
  }

  UNSAFE_componentWillMount() {
    SessionStore.addLoginListener(this.onLogin)
    ErrorStore.addErrorListener(this.onError)
  }

  componentWillUnmount() {
    SessionStore.removeLoginListener(this.onLogin)
    ErrorStore.removeErrorListener(this.onError)
  }

  onLogin() {
    this.props.handleLogin && this.props.handleLogin()
  }

  validateForm() {
    if (this.state.email.length === 0) this.setMessage('email')
    if (this.state.password.length === 0) this.setMessage('password')
    return (this.state.email.length > 0 && this.state.password.length > 0)
  }

  setMessage(field) {
    var val = this.state.validationMessage
    val[field] = field + ' is required.'
    this.setState({ validationMessage: val })
  }

  handleChange(event) {
    var val = this.state.validationMessage
    val[event.target.id] = ''
    this.setState({
      [event.target.id]: event.target.value,
      validationMessage: val
    })
  }

  handleSubmit(event) {
    event.preventDefault()
    if (this.validateForm()) {
      SessionActions.saveSession(this.componentId, this.state)
    }
  }

  onLoginFacebook(e) {
    if (e) {
      e.preventDefault()
    }
    FaceAPI.init()
      .then(
        () => { return FaceAPI.login({ scope: 'email' }) },
        error => { throw error }
      )
      .then(
        FaceAPI.fetch,
        error => { throw error }
      )
      .then(
        response => {
          if (!response['email']) {
            FaceAPI.logout()
            throw 'invalid email'
          }
          console.log('connected as ' + response['name'])
          SessionActions.saveSocialSession(this.componentId, response['email'], 'facebook')
        },
        error => { throw error }
      )
      .catch((error) => {
        console.warn(error)
      })
  }

  onLoginGoogle(response) {
    SessionActions.saveSocialSession(this.componentId, response['profileObj']['email'], 'google')
  }

  errorGoogle(response) {
    console.error(response)
  }

  onError(source, error) {
    if (source == this.componentId) {
      HandleException.handle_error(error);
    }
  }

  render() {
    return (
      <div className='login-form' >
        <div className='login-card text-center'>
          <div className='card'>
            <LogoImg />
            <div className='signal34-explore'>
              Explore, collect and access
            </div>
            <div className='signal34-explore'>
              your best content from anywhere!
            </div>
            <p />
            <div key={'form'} className='signal34-form'>
              <Form onSubmit={this.handleSubmit}>
                <Form.Group controlId='email'>
                  <Form.Control autoFocus type='email' value={this.state.email} onChange={this.handleChange} placeholder='Email' ref={this.emailRef} autoComplete='username' />
                  <Overlay show={this.state.validationMessage['email'] !== undefined && this.state.validationMessage['email'] !== ''} target={this.state.emailState} placement='right' container={() => this.container.current} containerPadding={20} >
                    <Popover id='popover-email' outOfBoundaries={true}>
                      <Popover.Body>
                        {this.state.validationMessage['email']}
                      </Popover.Body>
                    </Popover>
                  </Overlay>
                </Form.Group>
                <Form.Group controlId='password'>
                  <Form.Control value={this.state.password} onChange={this.handleChange} type='password' placeholder='Password' ref={this.passwordRef} autoComplete='password' />
                  <Overlay show={this.state.validationMessage['password'] !== undefined && this.state.validationMessage['password'] !== ''} target={this.state.passwordState} placement='right' container={() => this.container.current} containerPadding={20} >
                    <Popover id='popover-password' >
                      <Popover.Body>
                        {this.state.validationMessage['password']}
                      </Popover.Body>
                    </Popover>
                  </Overlay>
                </Form.Group>
                <div className='signal34-blue-button'>
                  <Button variant='primary' className='signal34-bnt-primary' type='submit'>Log in</Button>
                </div>
                <div className='signal34-or'>
                  OR
                </div>
                <div>
                  <div className='signal34-facebook' onClick={this.onLoginFacebook}>
                    <span className="svg-container">
                      <Image src='data:image/svg+xml;utf8,<svg enable-background="new 0 0 128 128" height="24px" id="Layer_1" version="1.1" viewBox="0 0 128 128" width="24px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><rect fill="%23FFFFFF" height="128" width="128"/></g><path d="M68.877,128V78.188h-17.78V60.425h17.784V44.029c0-16.537,9.764-26.279,24.514-26.279  c7.068,0,12.834,0.756,14.605,0.991v18.573l-11.874-0.005c-8.022,0-9.523,3.979-9.523,9.572v13.544h20.556l-2.904,17.763H86.603V128  H68.877z" fill="%233C579E"/></svg>' />
                    </span>
                    <span>Log In with Facebook</span>
                  </div>
                  <GoogleLogin clientId={clientId} onSuccess={this.onLoginGoogle} onFailure={this.errorGoogle} buttonText='Log In with Google' offline={false} className='signal34-google' />
                </div>
              </Form>
            </div>
            <div className='signal34-continuing'>
              By continuing you agree to Signal34&#39;s <span><a target='_blank' href='./personal_terms_of_service'>Terms of</a></span>
            </div>
            <div className='signal34-continuing'>
              <span><a target='_blank' href='./personal_terms_of_service'>Service</a></span> and <span><a target='_blank' href='./privacy_policy'>Privacy policy</a></span>
            </div>
            <div className='signal34-forgot'>
              <Link to={'/forgot_password/'}>Forgot your password?</Link>
              <svg viewBox="0 0 400 24" xmlns="http://www.w3.org/2000/svg">
                <line x1="130" y1="12" x2="270" y2="12" stroke="#EEEEEE" />
              </svg>
            </div>
            <div className='signal34-signup'>
              <span>
                <Link to={'/signup/'}>Not on Signal34 yet? Sign Up</Link>
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}